export default __webpack_public_path__ + "static/media/08.5248a32c.jpg";